<template>
    <ul class="menu">
      <li v-for="(item ,index) in list" :key="index">
        <p @click="toggleChildren($event,index,item)" :class="item.pclass">
          <router-link :to="{path:item.tolink}">
            <div style="display: flex; width: 100px;align-items: center;margin-left: 110px">
              <img v-if="item.src" :src="item.src" style="margin-right: 10px"/>
              <!-- {{item.name}}<i v-if="item.second" :class="jiaclass[index]"></i><i v-else :class="item.class"></i> -->
              {{item.name}}
              
            </div>
            <i v-if="item.second" :class="item.class" class="jia iconfont"></i><i v-else :class="item.class"></i>
          </router-link>  
        </p>
        <Menu v-show="item.show"  v-if="item.children&&item.children.length>0" :list='item.children'></Menu>
      </li>
    </ul>
</template>
<script>
import Text from '../utils/text'
export default {
  name:'Menu',
  comments:{},
  props:{
    list:{
      type:Array,
      default:[]
    }
  },
  data(){
    return {
      scopesDefault:[],
      show:false,
      jiaclass:new Array(10).fill('jia iconfont icon-jiahao')
    }
  },
  created(){

  },
  methods:{
    toggleChildren($event,index,item) {
      if(this.list[index].children&&this.list[index].children.length>0){
      const idx = this.list.indexOf(item)
      this.$set(this.list[idx], 'show', !item.show)
      }else{
        this.bus.$emit('closemenu')
      }
      if(item.second){
        item.class = item.class=='icon-jiahao'?'icon-jianhao':'icon-jiahao'
      }
      setTimeout(()=>{
        window.scrollTo(0,0)
      },10)
    }
  }
}
</script>
<style lang="scss">
  .menu{
    height:93%;
    overflow: scroll;
    li{
      line-height:94px;
      
      font-size:24px;
      position: relative;
      a,a:visited{
        display:block;
        width:100%;
        color:#01070f;
        text-decoration: none;
      }
      a:active{
        color:#01070f;
        text-decoration: none;
      }
      .bold{
        font-weight: bold;
      }
      .right,.down{
        content:'';
        position:absolute;
        top:36px;right:27px;
        width:17px;
        height:17px;
        border-width:0 2px 2px 0;
        border-color:#3e3e3f;
        border-style:solid;
      }
      .right{
        transform: rotate(-45deg);
      }
      .down{
        transform: rotate(45deg);
      }
      .jia{
        position:absolute;
        top:0;
        right:20px;
        font-size:16px;
      }
      p{
        padding-left:56px;
        border-bottom:1px solid #e7e7e7;
      }
      ul{
        p{
          padding-left:80px;
        }
        ul{
          p{
            padding-left:110px;
          }
        }
      }
    }
    li *{
      vertical-align: middle;
    }
    img{
      width:50px;height:50px;
      display:inline-block;
    }
  }
</style>